// The public demo refuses some saves (alert recipients, users, billing, support, sharing,
// integrations). The API answers 403 DEMO_READ_ONLY; show one small notice instead of
// each page's generic error.
let timer = null;

export function showDemoNotice(message = 'Not available in the demo. Nothing was changed.') {
  if (typeof document === 'undefined') return;
  let el = document.getElementById('demo-read-only-notice');
  if (!el) {
    el = document.createElement('div');
    el.id = 'demo-read-only-notice';
    el.setAttribute('role', 'status');
    Object.assign(el.style, {
      position: 'fixed', left: '50%', bottom: '24px', transform: 'translateX(-50%)', zIndex: '10000',
      background: '#1f2937', color: '#fff', padding: '12px 20px', borderRadius: '8px',
      boxShadow: '0 4px 16px rgba(0,0,0,0.25)', fontSize: '15px', maxWidth: '90vw', textAlign: 'center'
    });
    document.body.appendChild(el);
  }
  el.textContent = message;
  el.style.display = 'block';
  clearTimeout(timer);
  timer = setTimeout(() => { el.style.display = 'none'; }, 4000);
}

export function isDemoRefusal(error) {
  return error?.response?.status === 403 && error?.response?.data?.code === 'DEMO_READ_ONLY';
}
